import React, { ReactNode } from "react";

import "./header.css";

export const Header = ({
	children,
	left,
	right,
	center,
}: {
	children?: React.ReactNode;
	left?: ReactNode;
	right?: ReactNode;
	/** true: Mathematically center, false: Distribute space evenly */
	center?: boolean;
}) => (
	<header className={`header ${center ? "header--center" : ""}`}>
		{left && <div className="header__left">{left}</div>}
		{children && <div className="header__center">{children}</div>}
		{(right || children) && <div className="header__right">{right}</div>}
	</header>
);
Header.displayName = "Header";
